.collapsibleMenu {
  position: relative;
}

.container {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: absolute;
  width: 263px;
  right: -24px;
  top: 35px;
  padding-top: 20px;
  box-sizing: border-box;
  border-radius: 12px;
  cursor: default;
  z-index: 1000;
  @include themify($themes) {
    background-color: themed("main-secondary");
    box-shadow: 0 18px 24px themed("shadow");
    border: solid 1px themed("neutral-secondary");
    color: themed("main-primary");
  }

  max-height: 360px;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 11px;
  font-weight: 600;
  padding: 0 20px;
  margin-bottom: 18px;
  @include themify($themes) {
    color: themed("main-primary");
  }

  svg {
    height: 14px;
    width: 14px;
  }
}
